/**
 * Separador entre a sigla e a descrição no nome do Sensor: um traço **entre
 * espaços**.
 *
 * Qualquer traço, e não só o hífen: editores de texto trocam " - " por " – "
 * ao digitar, e nomes cadastrados assim (`AVR – Relé Regulador de Tensão`)
 * ficavam sem sigla. Vale hífen, travessões (– —), sinal de menos (−) e as demais
 * variantes Unicode de traço (U+2010 a U+2015); espaço não separável conta como
 * espaço, porque `\s` o inclui.
 *
 * Os espaços continuam obrigatórios. `BM - Monitor de Bucha` e
 * `BM-2 - Monitor de Bucha` são tipos diferentes de Sensor (ver Sensores de
 * mesmo módulo no CONTEXT.md); cortar no primeiro traço daria `BM` para os dois,
 * e o Ativo exibiria dois retângulos vizinhos com o mesmo rótulo.
 */
const ABBREVIATION_SEPARATOR = /\s[-‐-―−]\s/;

/**
 * Sigla do Sensor: o trecho do nome antes do primeiro traço entre espaços.
 *
 * Existe porque o nome completo não cabe dentro do retângulo do Sensor, e o
 * tooltip que hoje o revela não serve numa TV, onde não há mouse.
 *
 * Nome sem o separador não tem sigla: devolve o nome inteiro, que a célula corta
 * pelo que couber.
 *
 * @param {String} name Nome do Sensor (`nomeIed`).
 * @returns {String} A sigla, ou o nome inteiro quando não há separador.
 */
export default function getSensorAbbreviation(name) {
  const fullName = String(name || '').trim();
  const separator = ABBREVIATION_SEPARATOR.exec(fullName);

  if (!separator) {
    return fullName;
  }

  return fullName.slice(0, separator.index).trim();
}
